import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { applyAuth } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const params = new URLSearchParams(location.hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    if (!sessionId) { navigate("/giris", { replace: true }); return; }
    (async () => {
      try {
        const { data } = await api.post("/auth/google", { session_id: sessionId });
        const u = applyAuth(data);
        window.history.replaceState(null, "", window.location.pathname);
        navigate(u.role === "super_admin" ? "/admin" : "/panel", { replace: true });
      } catch (e) {
        toast.error("Google ile giriş başarısız oldu");
        navigate("/giris", { replace: true });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-3">
      <Loader2 className="w-8 h-8 animate-spin text-primary" />
      <p className="text-sm text-muted-foreground">Giriş yapılıyor…</p>
    </div>
  );
}
